import * as React from 'react';
import './App.css';

import { HomeScreen } from './screens/home.screen';

class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <HomeScreen/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx